/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Card/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import PaymentProviderMethod from 'DesignSystem/PaymentProvider/PaymentProviderMethod/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Card({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/ActiveStep/DownpaymentSetup/Pay/ChooseType/Widget/Card"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let payersActivetabOrganizationIdValueData = fromData.useDataValue({ viewPath,
context: 'payers',
path: 'activeTab.organization_id',
})
let payersActivetabPayerPersonValueData = fromData.useDataValue({ viewPath,
context: 'payers',
path: 'activeTab.payer_person',
})
let payersActivetabAccountTypeValueData = fromData.useDataValue({ viewPath,
context: 'payers',
path: 'activeTab.account_type',
})
  return (<React.Fragment
>
<div
  data-testid="Card.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-9dqY': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-2-9dqY': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<PaymentProviderMethod
  viewPath={`${viewPath}/PaymentProviderMethod`}
 reusableForBluefin={true}
 method="card"
 data="payers.activeTab.organization_id"
 locationId={payersActivetabOrganizationIdValueData}
 data="payers.activeTab.payer_person"
 person={payersActivetabPayerPersonValueData}
 data="payers.activeTab.account_type"
 paymentAccountType={payersActivetabAccountTypeValueData}
/>
</div>
{children}
</React.Fragment>)
}